import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link, StaticQuery, graphql } from 'gatsby'

import { Triangle, Email } from './icons'
import LogInContext from '../context/LogInContext'
import { reloadIfCurrentRoute } from '../helpers/pageUtils'

import '../sass/main.scss'
import ContentfulButton from './Utilities/Buttons/ContentfulButton'

class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hasScrolled: false,
      changeHeaderStyle: false
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  /* eslint-disable consistent-return */
  handleScroll = () => {
    if (this.props.dropInHeader?.current) {
      return window.pageYOffset > this.props.dropInHeader.current.offsetTop
        ? this.setState({ hasScrolled: true })
        : this.setState({ hasScrolled: false })
    }
  }

  handleHeaderChange = () => this.setState({ changeHeaderStyle: !this.state.changeHeaderStyle })

  render() {
    const { hasScrolled } = this.state
    const { heros } = this.props

    let headerClasses = []
    headerClasses.push(this.state.hasScrolled ? 'header-wrap sticky ' : 'header-wrap')
    const headerTheme = heros?.[0]?.theme
    if (headerTheme && headerTheme !== 'Default (Dark)') {
      headerClasses.push(headerTheme.toLowerCase().replaceAll(' ', '-'))
    }
    headerClasses = headerClasses.join(' ')

    let navItemsComp = []

    if (heros?.length && heros[0].navItems?.length) {
      const { navItems } = heros[0]
      navItems.map((item, index) =>
        navItemsComp.push(
          /* eslint-disable react/no-array-index-key */
          <ContentfulButton data={item} key={index} />
        )
      )
      navItemsComp = <div className="nav-items">{navItemsComp}</div>
    }

    return (
      <StaticQuery
        query={graphql`
          query {
            contentfulAsset(title: { eq: "Avant Slate White Logo Registered Trademark" }) {
              file {
                url
              }
            }
          }
        `}
        render={data => (
          <LogInContext.Consumer>
            {theme => (
              <header
                className={headerClasses}
                style={
                  this.state.changeHeaderStyle
                    ? { position: 'sticky', backgroundColor: '#2382ce' }
                    : null
                }
              >
                <div
                  className={
                    !this.props.noNavigation || (this.props.noNavigation && this.props.odsLogin)
                      ? 'container__inner'
                      : 'container__inner ods-nav'
                  }
                >
                  <div className={hasScrolled ? 'header header--no-border' : 'header'}>
                    <Link
                      to="/"
                      className="header__home"
                      data-event="home"
                      onClick={() => reloadIfCurrentRoute('/')}
                    >
                      <picture className="header__logo">
                        <source srcSet={data.contentfulAsset.file.url} media="(min-width: 70em)" />
                        <source
                          srcSet={require('../assets/images/logos/logo-avant-header-mobile.svg')}
                        />
                        <img src={data.contentfulAsset.file.url} alt="Avant Logo" />
                      </picture>
                    </Link>
                    {navItemsComp}
                    {((this.props.noNavigation && this.props.odsLogin) ||
                      !this.props.noNavigation) && (
                      <div className="navigation">
                        <input
                          className="navigation__checkbox"
                          type="checkbox"
                          id="menu_toggle"
                          name="menu_toggle"
                          onClick={this.handleHeaderChange}
                        />
                        <label className="navigation__button" htmlFor="menu_toggle">
                          <span className="navigation__icon">
                            <span className="hide-display">Menu</span>
                          </span>
                        </label>

                        <nav className="navigation__menu">
                          <div className="navigation__button-box">
                            {theme.isLoggedIn && (
                              <a
                                className=" button--primary"
                                href="/dashboard"
                                data-event="dashboard"
                              >
                                My Account
                              </a>
                            )}
                            <a
                              href={
                                theme.isLoggedIn
                                  ? `${process.env.GATSBY_BASE_URL}/logout`
                                  : `${process.env.GATSBY_BASE_URL}/login`
                              }
                              className="button--dropdown"
                              type="button"
                              data-event={theme.isLoggedIn ? 'logout' : 'login'}
                            >
                              {theme.isLoggedIn ? 'Log Out' : 'Log In'}
                            </a>
                          </div>

                          <ul className="navigation__list">
                            {!this.props.noNavigation && (
                              <>
                                <li className="navigation__item">
                                  {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                  <a className="navigation__link" href="" tabIndex="0">
                                    Products
                                  </a>

                                  <div className="sub-navigation">
                                    <ul className="sub-navigation__list">
                                      <li className="sub-navigation__item">
                                        <Link
                                          className="sub-navigation__link"
                                          to="/personal-loans/"
                                          data-event="personal loan"
                                          onClick={() => reloadIfCurrentRoute('/personal-loans/')}
                                        >
                                          Personal Loan
                                        </Link>
                                      </li>

                                      <li className="sub-navigation__item">
                                        <Link
                                          className="sub-navigation__link"
                                          to="/credit-card/"
                                          data-event="credit card"
                                          onClick={() => reloadIfCurrentRoute('/credit-card/')}
                                        >
                                          Credit Card
                                        </Link>
                                      </li>

                                      <li className="sub-navigation__item">
                                        <Link
                                          className="sub-navigation__link"
                                          to="/mobile-banking/"
                                          data-event="mobile banking"
                                          onClick={() => reloadIfCurrentRoute('/mobile-banking/')}
                                        >
                                          Mobile Banking
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </li>

                                <li className="navigation__item">
                                  <a className="navigation__link" href="" tabIndex="0">
                                    Support
                                  </a>

                                  <div className="sub-navigation">
                                    <ul className="sub-navigation__list">
                                      <li className="sub-navigation__item ">
                                        <a
                                          className="sub-navigation__link"
                                          href="https://support.avant.com/"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          data-event="frequently asked questions"
                                        >
                                          FAQ
                                        </a>
                                      </li>
                                      <li className="sub-navigation__item">
                                        <a
                                          className="sub-navigation__link"
                                          href="https://support.avant.com/article/234-how-can-i-contact-avant"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          data-event="contact us"
                                        >
                                          Contact Us
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </li>

                                <li className="navigation__item">
                                  <a className="navigation__link" href="" tabIndex="0">
                                    Company
                                  </a>

                                  <div className="sub-navigation">
                                    <ul className="sub-navigation__list">
                                      <li className="sub-navigation__item ">
                                        <Link
                                          className="sub-navigation__link"
                                          to="/about-us/"
                                          data-event="about us"
                                          onClick={() => reloadIfCurrentRoute('/about-us/')}
                                        >
                                          About Us
                                        </Link>
                                      </li>
                                      <li className="sub-navigation__item">
                                        <Link
                                          className="sub-navigation__link"
                                          to="/jobs/"
                                          data-event="jobs"
                                          onClick={() => reloadIfCurrentRoute('/jobs/')}
                                        >
                                          Careers
                                        </Link>
                                      </li>
                                      <li className="sub-navigation__item">
                                        <Link
                                          className="sub-navigation__link"
                                          to="/press/"
                                          data-event="press"
                                          onClick={() => reloadIfCurrentRoute('/press/')}
                                        >
                                          Press
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </li>

                                <li className="navigation__item" target="blog">
                                  <a
                                    className="navigation__link"
                                    href={`${process.env.GATSBY_BASE_URL}/blog`}
                                    rel="noopener noreferrer"
                                    data-event="blog"
                                    target="blog"
                                  >
                                    Blog
                                  </a>
                                </li>
                                <li className="navigation__item">
                                  {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                  <a className="navigation__link" href="" tabIndex="0">
                                    <Email className="button-group__icon" />
                                    Redeem Your Mail Offer
                                  </a>

                                  <div className="sub-navigation">
                                    <ul className="sub-navigation__list">
                                      <li className="sub-navigation__item">
                                        <Link
                                          className="sub-navigation__link"
                                          href="https://www.myavantoffer.com/"
                                          rel="noopener noreferrer"
                                          data-event="personal loan mail offer"
                                        >
                                          Personal Loan
                                        </Link>
                                      </li>

                                      <li className="sub-navigation__item">
                                        <Link
                                          className="sub-navigation__link"
                                          to="/content/myavantcard/"
                                          data-event="credit card mail offer"
                                          onClick={() =>
                                            reloadIfCurrentRoute('/content/myavantcard/')
                                          }
                                        >
                                          Credit Card
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                              </>
                            )}
                          </ul>

                          <div className="navigation__button-box--large">
                            {theme.isLoggedIn ? (
                              <>
                                <button
                                  className="navigation__account button--secondary"
                                  type="button"
                                >
                                  My Account
                                  <Triangle className="navigation__triangle-icon" />
                                </button>

                                <div className="navigation__button-drop-down">
                                  <ul className="navigation__button-list">
                                    <a className="navigation__button-link" href="/dashboard">
                                      <li className="navigation__button-item">My Account</li>
                                    </a>
                                    <a
                                      className="navigation__button-link"
                                      href={`${process.env.GATSBY_BASE_URL}/logout`}
                                      data-event="log out"
                                    >
                                      <li className="navigation__button-item">Log Out</li>
                                    </a>
                                  </ul>
                                </div>
                              </>
                            ) : (
                              <a
                                className="button--secondary"
                                href={`${process.env.GATSBY_BASE_URL}/login`}
                                data-event="login"
                              >
                                Log In
                              </a>
                            )}
                          </div>
                        </nav>
                      </div>
                    )}
                  </div>
                </div>
              </header>
            )}
          </LogInContext.Consumer>
        )}
      />
    )
  }
}

Header.defaultProps = {
  heros: null,
  noNavigation: false,
  odsLogin: false
}

Header.propTypes = {
  heros: PropTypes.object,
  dropInHeader: PropTypes.object.isRequired,
  noNavigation: PropTypes.bool,
  odsLogin: PropTypes.bool
}

export default Header
